/// //////////////////////////////////////////////////////////////////////////
//                                                                          //
//  本文件由WIDE自动生成框架，用来定义类似webcomponent的元素．                     //
//  本文件用于定义元素类。可以引入更多文件以将功能拆分到其它文件中。                   //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// //////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-22T13:11:40.666Z

'use strict'
import build from './compiler'

/**
返回本扩展库的版本号。
@method version
@param {array} [params=[]] 参数集
@param {Element} [refEle=undefined] 调用命令时的索引Dom Element.
@return {Promise<string>} 返回本扩展库的版本号
*/
function version () {
  return '<# VERSION #>'
}

function fromEditor (dummy, refEle) {
  console.log(arguments)
  return 123
}

export default {
  version: version,
  build: build,
  fromEditor: fromEditor
}
